import React, { useMemo } from 'react';
import { useIfUserEligible } from './useIfUserEligible';
import { FEATURES } from '../constants/features';

export function useAIFeatureEligibility() {
    const mediaEligibility = useIfUserEligible(FEATURES.AI_MEDIA_UPLOADS);
    const wheelEligibility = useIfUserEligible(FEATURES.AI_WHEEL_GENERATOR);

    return useMemo(() => ({
        eligibility: {
            media: {
                isEligible: mediaEligibility.isEligible,
                subscription: mediaEligibility.subscription,
                requiredSubscription: mediaEligibility.requiredSubscription
            },
            wheel: {
                isEligible: wheelEligibility.isEligible,
                remainingTokens: wheelEligibility.remainingTokens
            }
        },
        refetch: async () => {
            await Promise.all([
              mediaEligibility.checkFeatureEligibility(),
              wheelEligibility.checkFeatureEligibility()
            ]);
        }
    }), [mediaEligibility, wheelEligibility]);
}